module.exports = __webpack_public_path__ + "img/facebook.06cbb121.svg";